"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var BaseSlopeChart = /** @class */ (function (_super) {
    __extends(BaseSlopeChart, _super);
    function BaseSlopeChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseSlopeChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_valueFunc":
            case "_xFunc":
                return utils_1.parseFunc(value);
            case "_gapRatio":
                return utils_1.parseNumberWithAuto(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    BaseSlopeChart.prototype.defaultOptions = function () {
        return {
            _gapRatio: 0.05,
            _valueFunc: function (d) { return d.value; },
            _xFunc: function (d) { return d.x; },
        };
    };
    BaseSlopeChart.prototype.init = function () {
        var _this = this;
        this._yScaleLinear = d3.scaleLinear();
        this._toolTip = __1.tooltip.create("linetip");
        this._groups = this.appendGroupT(_1.Component).data([]).options({
            class: "group",
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._groups.dom)
                    .renderHTML(function (d) {
                    return "" + d[0].key;
                });
            },
            _$mouseEnter: function (d, i, g) {
                d3.select(g[i]).classed("active", true);
            },
            _$mouseLeave: function (d, i, g) {
                d3.select(g[i]).classed("active", false);
            },
        });
        this._labelStart = this._groups.appendT(element_1.Text).options({
            _anchor: 4 /* Middle */ | 64 /* Right */,
            _x: function (d) { return d[0].x2 - 20; },
            _y: function (d) { return _this._yScaleLinear(d[0].y1); },
            _text: function (d) { return d[0].key; },
        });
        this._labelX = this._groups.appendGroupT(element_1.Text).data([]).options({
            _data: function (d) { return d; },
            _anchor: 4 /* Middle */ | 32 /* Center */,
            _x: function (d) { return d.x2; },
            _y: function (d) { return _this._getGeometry("_height", false) + 10; },
            _text: function (d) { return d.x2Value.toString(); },
        });
    };
    BaseSlopeChart.prototype.prepare = function () {
        var _this = this;
        var keys = Object.keys(this.datum);
        this._cachedCanvasWidth = this._getGeometry("_width", true);
        this._cachedCanvasHeight = this._getGeometry("_height", false);
        this._gapRatio = this.getOption("_gapRatio");
        if (this._gapRatio < 0) {
            this._gapRatio = 0.05;
        }
        var groupCount = this.datum[keys[0]].length; // we assume each key has the same data length
        var gapTotalRatio = groupCount * this._gapRatio;
        var totalGap = this._cachedCanvasWidth * gapTotalRatio;
        /** length of projection of each line on x-axis */
        this._sectionWidth = (this._cachedCanvasWidth - totalGap) / (groupCount - 1);
        /** horizontal distance between each line */
        var gap = totalGap / groupCount;
        this._xFunc = this.getOption("_xFunc");
        this._valueFunc = this.getOption("_valueFunc");
        var dataYnum = [];
        var dataArray = keys.map(function (s) {
            var lineData = _this.datum[s].map(function (d, i, g) {
                var lastP = g[i - 1];
                if (i === 0) {
                    return {
                        x1: gap,
                        x2: gap,
                        y1: _this._valueFunc(g[0]),
                        y2: _this._valueFunc(g[0]),
                        key: s,
                        x1Value: _this._xFunc(d),
                        x2Value: _this._xFunc(d),
                    };
                }
                else {
                    dataYnum.push(_this._valueFunc(d));
                    return {
                        x1: _this._sectionWidth * (i - 1) + gap * i,
                        x2: _this._sectionWidth * i + gap * i,
                        y1: _this._valueFunc(lastP),
                        y2: _this._valueFunc(d),
                        key: s,
                        x1Value: _this._xFunc(lastP),
                        x2Value: _this._xFunc(d),
                    };
                }
            });
            return lineData;
        });
        this._groups.data(dataArray);
        this._yScaleLinear.domain([0, d3.max(dataYnum)]).nice().range([this._cachedCanvasHeight, 0]);
        this.setupProxy({
            line: "_lines",
            label: "_labelStart",
            labelX: "_labelX",
        });
    };
    return BaseSlopeChart;
}(_1.Component));
exports.BaseSlopeChart = BaseSlopeChart;
var ParallelChart = /** @class */ (function (_super) {
    __extends(ParallelChart, _super);
    function ParallelChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataYstring = {};
        _this.dataYnum = {};
        _this.scales = {};
        return _this;
    }
    ParallelChart.prototype.defaultOptions = function () {
        return __assign({}, _super.prototype.defaultOptions.call(this));
    };
    ParallelChart.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._lines = this._groups.appendGroupT(element_1.Line).data([]).options({
            _data: function (d) { return d; },
            x1: function (d) { return d.x1; },
            x2: function (d) { return d.x2; },
            y1: function (d) { return typeof (d.x1Value) === "number" ? _this.scales[d.x1Value](d.y1) : _this.scales[d.x1Value](d.y1) + _this.scales[d.x1Value].bandwidth() / 2; },
            y2: function (d) { return typeof (d.x2Value) === "number" ? _this.scales[d.x2Value](d.y2) : _this.scales[d.x2Value](d.y2) + _this.scales[d.x2Value].bandwidth() / 2; },
        });
        this._axes = this.appendGroupT(_1.Axis).data([]).options({
            _scale_isFunc: true,
            _scale: function (d) { return _this.scales[d.xValue]; },
            _gravity: __1.Gravity.Left,
            _x: function (d, i) { return d.x; },
            _y: 0,
            _includeStartEndTicks: function (d) { return typeof (d.xValue) === "number" ? true : false; },
        });
    };
    ParallelChart.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        var keys = Object.keys(this.datum);
        var dataYstr = {};
        keys.forEach(function (k) {
            _this.datum[k].forEach(function (d) {
                if (typeof (_this._valueFunc(d)) === "string") {
                    if (!dataYstr.hasOwnProperty("" + _this._xFunc(d))) {
                        dataYstr[_this._xFunc(d)] = [];
                        _this.dataYstring[_this._xFunc(d)] = [];
                    }
                    dataYstr[_this._xFunc(d)].push(_this._valueFunc(d));
                }
                else if (typeof (_this._valueFunc(d)) === "number") {
                    if (!_this.dataYnum.hasOwnProperty("" + _this._xFunc(d))) {
                        _this.dataYnum[_this._xFunc(d)] = [];
                    }
                    _this.dataYnum[_this._xFunc(d)].push(_this._valueFunc(d));
                }
            });
        });
        if (dataYstr !== null) {
            Object.keys(dataYstr).forEach(function (d) {
                var yscale = d3.scaleBand();
                _this.scales[d] = yscale.domain(dataYstr[d]).range([_this._cachedCanvasHeight, 0]);
            });
        }
        if (this.dataYnum !== null) {
            Object.keys(this.dataYnum).forEach(function (d) {
                var yscale = d3.scaleLinear();
                _this.scales[d] = yscale.domain(d3.extent(_this.dataYnum[d])).range([_this._cachedCanvasHeight, 0]);
            });
        }
        var dataAxis = this.datum[keys[0]].map(function (d, i) { return ({
            x: _this._sectionWidth * i + _this._gapRatio * i,
            xValue: _this._xFunc(d),
        }); });
        this._axes.data(dataAxis);
        this.setupProxy({
            axises: "_axises",
        });
    };
    return ParallelChart;
}(BaseSlopeChart));
exports.ParallelChart = ParallelChart;
var SlopeChart = /** @class */ (function (_super) {
    __extends(SlopeChart, _super);
    function SlopeChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlopeChart.prototype.defaultOptions = function () {
        return __assign({}, _super.prototype.defaultOptions.call(this));
    };
    SlopeChart.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._lines = this._groups.appendGroupT(element_1.Line).data([]).options({
            _data: function (d) { return d; },
            x1: function (d) { return d.x1; },
            x2: function (d) { return d.x2; },
            y1: function (d) { return _this._yScaleLinear(d.y1); },
            y2: function (d) { return _this._yScaleLinear(d.y2); },
        });
        this._labelValues = this._groups.appendGroupT(element_1.Text).data([]).options({
            _data: function (d) { return d; },
            _anchor: function (d, i) { return 4 /* Middle */ | (i === 0 ? 64 /* Right */ : 16 /* Left */); },
            _x: function (d, i) { return d.x2 + (i === 0 ? -3 : 3); },
            _y: function (d) { return _this._yScaleLinear(d.y2); },
            _text: function (d, i) { return "" + (i === 0 ? "  " : "") + d.y2; },
        });
    };
    SlopeChart.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this.setupProxy({
            label: "_labelValues",
        });
    };
    return SlopeChart;
}(BaseSlopeChart));
exports.SlopeChart = SlopeChart;
var BumpChart = /** @class */ (function (_super) {
    __extends(BumpChart, _super);
    function BumpChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BumpChart.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _radius: 2 });
    };
    BumpChart.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._lines = this._groups.appendGroupT(element_1.Line).data([]).options({
            _data: function (d) { return d; },
            x1: function (d) { return d.x1; },
            x2: function (d) { return d.x2; },
            y1: function (d) { return _this._yScaleLinear(d.y1); },
            y2: function (d) { return _this._yScaleLinear(d.y2); },
        });
        this._labelEnd = this._groups.appendT(element_1.Text).options({
            _anchor: 4 /* Middle */ | 16 /* Left */,
            _x: function (d) { return d[d.length - 1].x2 + 3; },
            _y: function (d) { return _this._yScaleLinear(d[d.length - 2].y2); },
            _text: function (d) { return d[d.length - 1].key; },
        });
        this._points = this._groups.appendGroupT(element_1.Circle).data([]).options({
            _data: function (d) { return d; },
            _r: function (d) { return _this.getOption("_radius"); },
            _anchor: 32 /* Center */ | 4 /* Middle */,
            _x: function (d) { return d.x2; },
            _y: function (d) { return _this._yScaleLinear(d.y2); },
            fill: "#fff",
        });
    };
    BumpChart.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        this.setupProxy({
            subBar: function (proxy) {
                _this._labelEnd.options(proxy.getAllOptions());
            },
            label: "_labelEnd",
        });
    };
    return BumpChart;
}(BaseSlopeChart));
exports.BumpChart = BumpChart;
//# sourceMappingURL=slope-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/slope-chart.js
// module id = 1160
// module chunks = 0 1